/*
input_text
scan_ocr
upload_pdf
import_icloud
import_dropbox
import_google_drive
import_bookshare
*/
export enum CreateMethod {
  INPUT_TEXT = "input_text",
  UPLOAD_PDF = "upload_pdf",
}

export interface BookData {
  book_id: string;
  book_title: string;
  book_num_words: number;
}

export interface BookDataCreate extends BookData {
  book_create_method: CreateMethod;
  book_num_ocr_pages?: number;
}

export type BookCreatedProperties = {
  data: BookDataCreate & {
    book_create_time_spent: number;
    book_create_processing_time?: number;
  };
};

export type BookFailedProperties = {
  data: BookDataCreate;
};
